<div [hidden]="!valid" id="container" #container></div>